import React, { useState, useEffect }  from 'react';
import { useDispatch } from 'react-redux';

import Title from '../../components/Title';
import { PdfIcon, JpgIcon } from '../../static';

import { timeHelper} from '../../helper/timeHelper';
import { setPopup } from '../../app/actions/uiActions';

import './styles.scss';

const PatientDocument = ({document}) => {
	const dispatch = useDispatch();
	const [documentData, setDocumentData] = useState({
		time: '',
		type: true,
		position: '',
		authorFullName: '',
		notes: '',
	});

	const handleClick = (e) => {
		e.preventDefault()
		dispatch(setPopup({
			imgId: document.s3id,
			active: true
		}));
	};

	useEffect(() => {
		const position = document.docAuthor === 'doctor' ? 'Dr' : '';
		const time = timeHelper(document.timestamp.seconds);
		const type = document.type === 'image/png' || document.type === 'image/jpeg' ? true : false;

		setDocumentData({
			type,
			time,
			position,
			authorFullName: document.authorFullName,
			notes: document.notes,
		});

	},[document]);

	return (
		<article className="patient-document">
			<div className="patient-document__date">
				{`${documentData.time} ago`} 
			</div>
			<div className="patient-document__added-by">
				{`Added by ${documentData.position} ${documentData.authorFullName}`}
			</div>
			
			<div className="patient-document__desc">
				{documentData.notes}
			</div>  
			<div 
				className="patient-document__file" 
				onClick={handleClick}
			>
				<div className="patient-document__icon">
					{
						documentData.type ? <JpgIcon />: <PdfIcon /> 
					}
				</div>
				<div>
					<div className="patient-document__file-title">
						<Title text={"Antibody Test Results"} isTexStart isLight isBold/>
					</div> 
					<a 
						href="/" 
						className="patient-document__file-share"
					>
						Share with Patient
					</a> 
				</div>
			</div>
		</article>
	);
};

export default PatientDocument;
